import segment from './segment';
import appsFlyer from './apps-flyer';
import datadog from './datadog';
import cookiebot from './cookiebot';

export default {
    cookiebot,
    segment,
    appsFlyer,
    datadog,
};
